export enum EmployeeGroupingEnum {
  NONE = 'none',
  JOB_TITLE = 'jobTitle',
  EMPLOYMENT_CONDITION = 'employmentCondition',
  WORKING_TIME = 'workingTime',
}
